import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@telus-uds/components-web';
import { useLocaleContext } from '../../context/LocaleContext';
import useReportingStrings from '../utils/useReportingStrings';

// "Last updated HH:mm" line with the sentence that explains how fresh the numbers are and a
// Refresh button (spec FR-014 to FR-016). `throttled` is true when the server answered a Refresh
// with the cached result because the user had just refreshed.
export const formatTime = (value, locale) => {
  const date = value ? new Date(value) : null;
  if (!date || Number.isNaN(date.getTime())) return '';
  return date.toLocaleTimeString(locale || 'en-US', { hour: '2-digit', minute: '2-digit', hour12: false });
};

const LastUpdated = ({
  generatedAt, throttled, loading, onRefresh
}) => {
  const locale = useLocaleContext();
  const strings = useReportingStrings();
  const time = formatTime(generatedAt, locale);
  if (!time) return null;

  return (
    <div
      data-testid="last-updated"
      style={{
        display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '0.75rem', margin: '0 0 1rem'
      }}
    >
      <span style={{ fontWeight: 600 }}>{`${strings.lastUpdated} ${time}`}</span>
      <Button variant={{ priority: 'low' }} onClick={onRefresh} disabled={loading}>
        {loading ? strings.refreshing : strings.refresh}
      </Button>
      {throttled && <span role="status" data-testid="already-up-to-date">{strings.alreadyUpToDate}</span>}
      <span style={{ flexBasis: '100%', fontSize: '0.875rem', color: '#666666' }}>
        {strings.refreshExplanation}
      </span>
    </div>
  );
};

LastUpdated.propTypes = {
  generatedAt: PropTypes.string,
  throttled: PropTypes.bool,
  loading: PropTypes.bool,
  onRefresh: PropTypes.func.isRequired
};

LastUpdated.defaultProps = {
  generatedAt: null,
  throttled: false,
  loading: false
};

export default LastUpdated;
